import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatButtonModule, MatCheckboxModule } from '@angular/material';
import { MatFormFieldModule } from '@angular/material';
import { MatInputModule } from '@angular/material';
import { MatDatepickerModule, MatNativeDateModule } from '@angular/material';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatTabsModule } from '@angular/material/tabs';
import { LocationStrategy, HashLocationStrategy, TitleCasePipe } from '@angular/common';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgxPaginationModule } from 'ngx-pagination';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { Ng2SearchPipeModule } from 'ng2-search-filter';
import { AppComponent } from './app.component';
import { ErrorHandler } from './shared/ErrorHandler';
import { HeaderComponent } from './common/header/header.component';
import { Level1menuComponent } from './common/level1menu/level1menu.component';
import { HomepageComponent } from '../app/homepage/homepage.component';
import { FooterComponent } from '../app/common/footer/footer.component';
import { ReportsComponent } from '../app/reports/reports.component';
import { AuthGuard } from './auth/auth.guard';
import { AppRoutingModule } from './app-routing.module';
import { UserService } from './shared/user.service'; // Import UserService

import { RegistrationComponent } from './registration/registration.component';
//import { LoginComponent } from './registration/login/login.component';
import { ApplicantLoginComponent } from './registration/applicant-login/applicant-login.component';
import { EmployeeLoginComponent } from './registration/employee-login/employee-login.component';
import { ApplicantRegisterComponent } from './registration/applicant-register/applicant-register.component';
import { ApplicantRegisterFormComponent } from './registration/applicant-register-form/applicant-register-form.component';

//start applicant //saheb
import { ApplicantComponent } from '../app/applicant/applicant.component';
import { StatusviewComponent } from '../app/applicant/status/statusview/statusview.component';
import { AppstatusComponent } from '../app/applicant/appstatus/appstatus.component';
import { ApplicationinstallmentpayComponent } from '../app/applicant/applicationinstallmentpay/applicationinstallmentpay.component';
import { ApplicationcancellationComponent } from '../app/applicant/applicationcancellation/applicationcancellation.component';
import { ApplicationrefundComponent } from '../app/applicant/applicationrefund/applicationrefund.component';
import { ApplicationViewComponent } from '../app/applicant/application-view/application-view.component';
import { ProfileComponent } from '../app/applicant/profile/profile.component';
import { OfflineApplicationGridComponent } from '../app/applicant/offline-application/offline-application-grid/offline-application-grid.component';
import { offlineapplicationComponent } from '../app/applicant/offline-application/offline-application.component';
import { ChangeRequestComponent } from '../app/applicant/change-request/change-request.component';
import { AllotNotallotComponent } from '../app/applicant/allot-notallot/allot-notallot.component';
import { ActivelistComponent } from '../app/applicant/apply/activelist/activelist.component';
import { ApplicationstatusComponent } from '../app/applicant/applicationstatus/applicationstatus.component';
import { ReviseBasePriceComponent } from '../app/applicant/revise-base-price/revise-base-price.component';
import { ReviseBaseGridComponent } from '../app/applicant/revise-base-price/revise-base-grid/revise-base-grid.component';
import { ApplicantDetailsUpdateComponent } from '../app/applicant/applicant-details-update/applicant-details-update.component';
import { ApplicantPaymentComponent } from '../app/applicant/applicant-payment/applicant-payment.component';
import { ChangeAddressComponent } from '../app/applicant/change-address/change-address.component';
import { BidderViewComponent } from '../app/applicant/bidder-view/bidder-view.component';
import { RefundRequestComponent } from '../app/applicant/refund-request/refund-request.component';
import { PaymentComponent } from '../app/applicant/payment/payment.component';
import { TransactionDetailsComponent } from '../app/applicant/transaction-details/transaction-details.component';
import { ApplicantQueryComponent } from '../app/applicant/applicant-query/applicant-query.component';
import { DirectAllocationComponent } from '../app/applicant/direct-allocation/direct-allocation.component';
import { ApplicantMenuComponent } from '../app/applicant/applicant-menu/applicant-menu.component'; //important
import { InstallmentPaymentFormComponent } from '../app/applicant/installment-payment/installment-payment-form/installment-payment-form.component';
import { QueryApplicantComponent } from '../app/applicant/query-applicant/query-applicant.component';
import { ApplicationOnlineViewComponent } from '../app/applicant/application-online-view/application-online-view.component';

import { ApplicationformComponent } from './allocation/forms/applicationform/applicationform.component';
import { EmpChangeAddressComponent } from './hrms/emp-change-address/emp-change-address.component';
import { HrmsComponent } from './hrms/hrms.component';
import { EmpPayslipComponent } from './hrms/emp-payslip/emp-payslip.component';
import { EmpBankDetailsComponent } from './hrms/emp-bank-details/emp-bank-details.component';
import { EmpNominationComponent } from './hrms/emp-nomination/emp-nomination.component';
import { EmpApplyLeaveComponent } from './hrms/emp-apply-leave/emp-apply-leave.component';
import { HrmsMenuComponent } from './hrms/hrms-menu/hrms-menu.component';
import { UltilitiesMenuComponent } from './ultilities/ultilities-menu/ultilities-menu.component';
import { UltilitiesComponent } from './ultilities/ultilities.component';
import { ChangePasswordComponent } from './ultilities/change-password/change-password.component';
import { SidebarComponent } from './common/sidebar/sidebar.component';
import { BaseComponent } from './common/base/base.component';
import { RtiOnlineComponent } from './rtionline/rtionline.component';
import { SubmitRequestFormComponent } from './rtionline/submitrequest/submitrequest-form/submitrequest-form.component';
import { SubmitRequestGridComponent } from './rtionline/submitrequest/submitrequest-grid/submitrequest-grid.component';
import { RegistrationNewComponent } from './registration/registration-new/registration-new.component';
import { FormApplicationComponent } from './registration/form-application/form-application.component';
import { VerifyRegisterComponent } from './registration/verify-register/verify-register.component';
import { Page3Component } from './registration/page3/page3.component';
import { Page2Component } from './registration/page2/page2.component';
import { Page1Component } from './registration/page1/page1.component';
import { EmpComplaintComponent } from './hrms/emp-complaint/emp-complaint.component';
import { TermsConditionComponent } from './registration/terms-condition/terms-condition.component';
import { ConfirmPawordComponent } from './registration/confirm-password/confirm-password.component';
import { ForgotPasswordOtpComponent } from './registration/forgot-password-otp/forgot-password-otp.component';
import { ForgotPasswordComponent } from './registration/forgot-password/forgot-password.component';
import { EmpLeaveEncashmentComponent } from './hrms/emp-leave-encashment/emp-leave-encashment.component';
import { PaymentFailureComponent } from './registration/payment-failure/payment-failure.component';
import { PaymentSuccessComponent } from './registration/payment-success/payment-success.component';
import { RegisPaymentSummaryComponent } from './registration/regis-payment-summary/regis-payment-summary.component';
import { AppformPaymentSummaryComponent } from './registration/appform-payment-summary/appform-payment-summary.component';
import { AgainstNotificationFormComponent } from './registration/against-notification-form/against-notification-form.component';
import { AgainstNotificationForm2Component } from './registration/against-notification-form2/against-notification-form2.component';
import { AgainstNotificationForm3Component } from './registration/against-notification-form3/against-notification-form3.component';
import { AgainstNotificationForm4Component } from './registration/against-notification-form4/against-notification-form4.component';
import { AgainstNotificationForm5Component } from './registration/against-notification-form5/against-notification-form5.component';
import { AgainstNotificationForm6Component } from './registration/against-notification-form6/against-notification-form6.component';

//start allocation

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    Level1menuComponent,
    SidebarComponent,
    BaseComponent,
    HomepageComponent,
    FooterComponent,
    ReportsComponent,
    RegistrationComponent,   
    ApplicantLoginComponent,
    PaymentFailureComponent,
    PaymentSuccessComponent,
    EmployeeLoginComponent,
    ApplicantRegisterComponent,
    RegistrationNewComponent,
    VerifyRegisterComponent,
    Page3Component,
    TermsConditionComponent,
    Page2Component,
    Page1Component,
    RegisPaymentSummaryComponent,AppformPaymentSummaryComponent,
    FormApplicationComponent,AgainstNotificationFormComponent,AgainstNotificationForm2Component,AgainstNotificationForm3Component,AgainstNotificationForm4Component,AgainstNotificationForm5Component,AgainstNotificationForm6Component,
    ApplicantRegisterFormComponent,
    ConfirmPawordComponent,ForgotPasswordOtpComponent,ForgotPasswordComponent,
    EmpComplaintComponent,
    ApplicantMenuComponent,
    ApplicantComponent, StatusviewComponent, AppstatusComponent, ApplicationinstallmentpayComponent, ApplicationcancellationComponent, ApplicationrefundComponent, ApplicationViewComponent, ProfileComponent, OfflineApplicationGridComponent, offlineapplicationComponent, ChangeRequestComponent, AllotNotallotComponent, ActivelistComponent, ApplicationstatusComponent,
    ReviseBasePriceComponent, ReviseBaseGridComponent, ApplicantDetailsUpdateComponent, ApplicantPaymentComponent, ChangeAddressComponent, BidderViewComponent, RefundRequestComponent, PaymentComponent, TransactionDetailsComponent, ApplicantQueryComponent, DirectAllocationComponent,InstallmentPaymentFormComponent,QueryApplicantComponent,ApplicationOnlineViewComponent,
    ApplicationformComponent,HrmsComponent,EmpChangeAddressComponent,EmpApplyLeaveComponent,EmpNominationComponent,EmpBankDetailsComponent,EmpPayslipComponent,HrmsMenuComponent,UltilitiesMenuComponent,  UltilitiesComponent,ChangePasswordComponent,RtiOnlineComponent,SubmitRequestGridComponent,SubmitRequestFormComponent
    ,EmpLeaveEncashmentComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    MatButtonModule, MatCheckboxModule, MatRadioModule,
    MatFormFieldModule,
    MatInputModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatCheckboxModule,
    MatSelectModule,
    FormsModule,
    MatTabsModule,
    ReactiveFormsModule,
    HttpClientModule,
    NgxPaginationModule,
    Ng2SearchPipeModule,
    NgbModule.forRoot(),
    AppRoutingModule
  ],
  providers: [
    UserService, ErrorHandler, AuthGuard, { provide: LocationStrategy, useClass: HashLocationStrategy },
    TitleCasePipe
    // {
    //   provide: HTTP_INTERCEPTORS,
    //   useClass: ErrorHandler,
    //   multi: true
    // }

  ],
  bootstrap: [AppComponent]
})
export class AppModule { }


// WEBPACK FOOTER //
// ./src/app/app.module.ts